import Key from '@/services/api/key.js';

export default {
  namespaced: true,
  state: {
    freeKeys: [],
    keys: [],
    key: {},
    keyGroups: [],
    authors: [],
    keysForDoorphone: [],
    cardStatus: null,
    keyDoorphones: [],
    keyDoorphonesPagination: null,
  },
  getters: {
    keyGroups: state => state.keyGroups,
    authors: state => state.authors,
    freeKeys: state => state.freeKeys,
    keys: state => state.keys,
    key: state => state.key,
    keysForDoorphone: state => state.keysForDoorphone,
    cardStatus: state => state.cardStatus,
    keyDoorphones: state => state.keyDoorphones,
    keyDoorphonesPagination: state => state.keyDoorphonesPagination,
  },
  mutations: {
    setKeys: (state, keys) => {
      state.keys = keys;
    },
    setAuthors: (state, authors) => {
      state.authors = authors;
    },
    setUniversalKeys: (state, keyGroups) => {
      state.keyGroups = keyGroups;
    },
    setKey: (state, key) => {
      state.key = key;
    },
    setKeysForDoorphone: (state, keysForDoorphone) => {
      state.keysForDoorphone = keysForDoorphone;
    },
    setCardStatus: (state, cardStatus) => {
      state.cardStatus = cardStatus;
    },
    setKeyDoorphones: (state, doorphones) => {
      state.keyDoorphones = doorphones;
    },
    setKeyDoorphonesPagination: (state, pagination) => {
      state.keyDoorphonesPagination = pagination;
    },
  },
  actions: {
    getKeys (state, options = {}) {
      return new Promise((resolve, reject) => {
        Key.getKeys(options)
          .then(({ data }) => {
            state.commit('setKeys', data.keys);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getUniversalKeyGroups (state, options = {}) {
      return new Promise((resolve, reject) => {
        Key.getUniversalKeyGroups(options)
          .then(({ data }) => {
            state.commit('setUniversalKeys', data.key_groups);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    searchByUniversalCode (state, options = {}) {
      return new Promise((resolve, reject) => {
        Key.searchByUniversalCode(options)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getKey (state, id) {
      return new Promise((resolve, reject) => {
        Key.getKey(id)
          .then(({ data }) => {
            state.commit('setKey', data.key);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getKeyDetail (state, { id, options = {} }) {
      return new Promise((resolve, reject) => {
        Key.getKeyDetail(id, options)
          .then(({ data }) => {
            state.commit('setKey', data.key);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    exportKeyDoorphonesCsv (state, id) {
      return new Promise((resolve, reject) => {
        Key.exportKeyDoorphonesCsv(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    updateKey (state, { id, code, name, universal, internalReaders, comment, externalReaders }) {
      Key.updateKey({ id, code, name, universal, internalReaders, comment, externalReaders })
        .then(({ data }) => {
          state.commit('setKey', data.key);
        })
        .catch(e => console.error(e));
    },
    deleteKey (state, id) {
      return new Promise((resolve, reject) => {
        Key.deleteKey(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => console.error(e));
      });
    },
    newKey (state, { code, name, universal, agent_id, internalReaders, comment, externalReaders }) {
      Key.newKey({ code, name, universal, agent_id, internalReaders, comment, externalReaders })
        .catch(e => console.error(e));
    },
    newDoorphoneKey (state, { doorphoneId, key }) {
      return new Promise((resolve, reject) => {
        Key.newDoorphoneKey({ doorphoneId, key })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    exportCsv (state, { agentId, doorphoneId }) {
      return new Promise((resolve, reject) => {
        Key.exportCsv({ agentId, doorphoneId })
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    import (state, { doorphoneId, duplicate }) {
      return new Promise((resolve, reject) => {
        Key.import(doorphoneId, duplicate)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    export (state, doorphoneId) {
      return new Promise((resolve, reject) => {
        Key.export(doorphoneId)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getCardStatus (state, doorphoneId) {
      return new Promise((resolve, reject) => {
        Key.getCardStatus(doorphoneId)
          .then(({ data }) => {
            state.commit('setCardStatus', data['keys-status']);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    setCardStatus (state, { doorphoneId, status }) {
      return new Promise((resolve, reject) => {
        Key.setCardStatus({ doorphoneId, status })
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    readKey (state) {
      return new Promise((resolve, reject) => {
        Key.readKey()
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getKeyAuthors (state) {
      return new Promise((resolve, reject) => {
        Key.getKeyAuthors()
          .then((data) => {
            state.commit('setAuthors', data.data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getKeyDoorphones (state, { id, options = {} }) {
      return new Promise((resolve, reject) => {
        Key.getKeyDoorphones(id, options)
          .then(({ data }) => {
            state.commit('setKeyDoorphones', data.doorphones);
            state.commit('setKeyDoorphonesPagination', data.pagination);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
  },
};
